import { ContentfulMediaMentions } from 'api/contentful/getContentfulMediaMention'
import { Block } from 'components/Block'
import { GoodTrustReferences } from 'components/estatePlanning/landing/references/GoodTrustReferences'
import { BlankTopNavigation } from 'components/header/topNavigationLandingPage/BlankTopNavigation'
import { Icon } from 'components/icon'
import { Layout } from 'components/layout/Layout'
import { PageTitle } from 'components/PageTitle'
import { PerksList } from 'components/perksList/PerksList'
import { SimpleFlowSignupForm } from 'components/SimpleFlowSignupForm/SimpleFlowSignupForm'
import { HStack, Stack } from 'components/Stack'
import { handleAndToastError } from 'components/Toast'
import { Caption, Title, Title_h4_default } from 'components/Typography'
import { createDirectiveAndRedirect } from 'logic/directive/create/create'
import { SimpleFlowDirectiveType } from 'logic/directive/types'
import { Trans, useTranslation } from 'next-i18next'
import Router, { useRouter } from 'next/router'
import { FC } from 'react'
import { useAuth } from 'utils/auth/hooks/useAuth'
import { colors } from 'utils/colors'
import { numberRange } from 'utils/general'
import { useRunOnceAllValuesAreDefined, useRunOnceReady } from 'utils/hooks'
import { SList, SWrapper } from './SimgpleFlowSignup.styled'
import { tryStorePromoCode } from 'utils/promo'

interface PageProps {
  mediaMentions: ContentfulMediaMentions
  flowDirective?: SimpleFlowDirectiveType
}

export const SimpleFlowSignup: FC<PageProps> = (props) => {
  const { isLogged } = useAuth()
  const { t } = useTranslation('auth')
  const router = useRouter()

  useRunOnceAllValuesAreDefined([isLogged] as const, ([isLogged]) => {
    if (isLogged) {
      if (props.flowDirective) {
        createDirectiveAndRedirect(props.flowDirective, {
          isLogged,
          routerMechanism: 'replace',
        }).catch(handleAndToastError)
      } else {
        Router.replace('/pricing')
      }
    }
  })

  useRunOnceReady(!!router.query.promo, () => {
    if (typeof router.query.promo === 'string') {
      tryStorePromoCode(router.query.promo)
    }
  })

  return (
    <Layout header={<BlankTopNavigation />}>
      <PageTitle title={t('auth.signup.meta_title')} />
      <Block>
        <SWrapper>
          <LeftColumn {...props} />
          <SimpleFlowSignupForm flowDirective={props.flowDirective} />
        </SWrapper>
      </Block>
    </Layout>
  )
}

const LeftColumn: FC<PageProps> = ({ mediaMentions }) => {
  const { t } = useTranslation('entrance')

  const caption = t('entrance.trust_signup.caption')
  const title = t('entrance.trust_signup.title')
  const mediaMentionTitle = t('entrance.trust_signup.media_mentions_title')

  return (
    <HStack css={{ alignItems: 'center', justifyContent: 'center' }}>
      <Stack space={'1.5rem'}>
        <Caption>{caption}</Caption>
        <Title variant={Title_h4_default} as="h1">
          {title}
        </Title>

        <SList>
          <PerksList
            titleOnly
            icon={<Icon name="CheckSimple" color={colors.blue[500]} />}
            perks={numberRange(4).map((i) => {
              return { title: <Trans t={t} i18nKey={`entrance.trust_signup.perks.perk_${i}`} /> }
            })}
          />
        </SList>
        <HStack space="2rem" css={{ alignItems: 'flex-end' }}>
          <GoodTrustReferences
            mediaMentions={mediaMentions}
            caption={mediaMentionTitle}
            responsiveItemCounts={[4, 4, 4]}
          />
        </HStack>
      </Stack>
    </HStack>
  )
}
